import styled, {ThemeProvider} from 'styled-components';
import {getTheme} from '@ey/styled-theme';
import React, {useEffect, useState} from 'react';
import TextLink from '../../../../../Common/BaseComponentWrappers/MotifTextLink';
import {labels} from '../../../../../../util/utils';
import {helixViewerError} from '../../../../../../util/uiconstants';
import HelixWrapperV2 from '../../../../../../util/HelixWrapperV2';
import Button from '../../../../../Common/BaseComponentWrappers/MotifButton';
import env from '../../../../../../util/env';
export default function HelixV2BodyTab(props) {
	const {showEYHelixSetup, engagementId, isHelixEnabled, helixFilters, bodyId} = props;
	const [helixDeepLinkUrl, setHelixDeepLinkUrl] = useState();
	const [hasAccessToHelixProject, setHasAccessToHelixProject] = useState(true);

	const handleOnClickNavigate = (e) => {
		e.preventDefault();
		const helixConfigurationsUrl = env.getURL('hercules_web') + '/connections?engagementid=' + engagementId;
		window.open(helixConfigurationsUrl, '_blank');
	};

	const helixSetupURL = () => {
		const errorMessage = labels.helixURLErrorMessage2;
		const splitValue = errorMessage.split('{0}');

		return (
			<>
				{isHelixEnabled ? (
					<HelixErrorMessage className="standalone HelixErrorMessage">
						<section>{labels.helixURLErrorMessage1}</section>
						<section>
							{splitValue[0]}
							<Button
								variant="text-alt"
								className="helixSetURL"
								onClick={handleOnClickNavigate}
								showLabel
								isEllipsed
								buttonLabel={labels.helixSetup}
								noOfLines={1}
							/>
							{splitValue[1]}
						</section>
					</HelixErrorMessage>
				) : (
					<HelixErrorMessage className="HelixErrorMessage">
						<section>{labels.helixIsNotEnabledMessage}</section>
					</HelixErrorMessage>
				)}
			</>
		);
	};

	const handleUnauthorizedCallback = (error) => {
		if (error && error.errorCode === helixViewerError.errorFetchingToken) {
			setHasAccessToHelixProject(false);
		}
	};

	const helixViewerLoaded = (event) => {
		console.log('helixViewerLoaded: ', event);
		const hxApi = event?.detail?.api;
		const viewerId = event?.detail?.viewerId;
		hxApi.generateHelixAnalyzerUrlWithState().then((response) => {
			if (Number(viewerId) === bodyId) {
				setHelixDeepLinkUrl(response.url);
			}
		});
	};

	useEffect(() => {
		document.addEventListener('helixViewerLoaded', helixViewerLoaded);
		return () => {
			document.removeEventListener('helixViewerLoaded', helixViewerLoaded);
		};
	}, []);

	return (
		<ThemeProvider theme={getTheme()}>
			<StyledHelixV2BodyTab className="StyledHelixV2BodyTab">
				{showEYHelixSetup || !hasAccessToHelixProject ? (
					helixSetupURL()
				) : (
					<>
						{helixFilters && (
							<HelixWrapperV2
								id={bodyId}
								wcName="hx-viewer"
								className="helix-viewer"
								initialVisual={helixFilters}
								unAuthorizedCallback={handleUnauthorizedCallback}
							/>
						)}
					</>
				)}
				{helixDeepLinkUrl && (
					<StyledModalFooter className="StyledModalFooter">
						<TextLink
							className="helixURL"
							variant="alt"
							target="_blank"
							href={helixDeepLinkUrl}
							isEllipsed
							label={labels.openAnalysisInHelix}
						/>
					</StyledModalFooter>
				)}
			</StyledHelixV2BodyTab>
		</ThemeProvider>
	);
}

const StyledHelixV2BodyTab = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	justify-content: center;
	.helix-viewer {
		hx-viewer {
			display: block;
			height: 100%;
			width: 100%;
			position: relative;
			.application-container {
				position: relative;
				height: 100%;
				width: 100%;
			}
			.pbi-report-container,
			.hx-viewer-container {
				background: transparent;
				position: static;
				height: 80vh;
				@media only screen and (min-width: 768px) and (max-width: 1280px) {
					height: 70vh;
				}
				iframe {
					padding: 0 var(--px-20) 0 var(--px-20);
					position: absolute;
					height: 100%;
					width: 100%;
					top: 0;
					left: 0;
				}
			}
		}
	}
`;

const StyledModalFooter = styled.footer`
	height: var(--px-60);
	padding: var(--px-10) var(--px-24);
	display: flex;
	align-items: center;
	border-top: var(--px-1) solid var(--neutrals-200);
	justify-content: flex-end;
	button {
		margin-right: var(--px-20);
		.ellipses {
			div {
				text-align: center;
				width: 100%;
			}
		}
	}
`;

const HelixErrorMessage = styled.section`
	width: 100%;
	height: 93%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: var(--px-24);
	font-weight: 300;
	line-height: var(--px-32);
	color: var(--neutrals-700);
	.helixSetURL {
		font-size: var(--px-24);
		font-weight: bold;
		line-height: var(--px-32);
		color: var(--blue-600);
		&:hover {
			border-bottom: 0 !important;
		}
	}
`;
